import React from 'react'
import { StarFilled } from '@ant-design/icons'
import { Rate } from 'antd'
import type {
  PublicCmsItemBusinessReviewCard,
  PublicProfileProduct,
} from 'apollo-gql'
import Image from 'next/image'

import Link from 'components/Link/Link'
import { Box } from 'components/UI/Box/Box'
import { Card } from 'components/UI/Card/Card'
import {
  BodySmall,
  BodyTextBold,
  H3,
  MetaText,
} from 'components/UI/Typography/Typography.new'

import styles from './BusinessReviewCard.module.css'

const B2B_PRODUCTS = [
  'VIDEO_REQUEST_BUSINESS',
  'VIDEO_REQUEST_BUSINESS_INTERNAL',
]

export type BusinessReviewCardProps = PublicCmsItemBusinessReviewCard & {
  profileProducts: [PublicProfileProduct]
}

const BusinessReviewCard: React.FC<BusinessReviewCardProps> = ({
  profileProducts,
  requestOccasion,
  review,
  reviewer,
  rating,
  date,
}) => {
  const b2bProduct = profileProducts?.find(({ product }) => {
    return B2B_PRODUCTS.includes(product.productType)
  })
  if (!b2bProduct) {
    return null
  }
  const { profile } = b2bProduct
  return (
    <div className={styles.businessReviewCard}>
      <Box className={styles.cardBox}>
        <div className={styles.container}>
          <div className={styles.review}>
            <div className={styles.occasion}>
              <H3 strict element="h4">
                {requestOccasion.title}
              </H3>
            </div>
            <div className={styles.rating}>
              <Rate
                className={styles.ratingRate}
                character={<StarFilled className={styles.ratingStar} />}
                value={rating}
                disabled
              />
            </div>
            <div className={styles.reviewText}>
              <BodySmall element="p" theme="tertiary">
                {review}
              </BodySmall>
            </div>
            <div className={styles.reviewerBlock}>
              <div className={styles.companyLogo}>
                <Image
                  src={reviewer.companyLogo.url}
                  alt={reviewer.companyName}
                  width="200"
                  height="40"
                  layout="intrinsic"
                  unoptimized
                  objectFit="scale-down"
                  objectPosition="left center"
                />
              </div>
              <span className={styles.colorGrey}>
                <div className={styles.reviewer}>
                  <BodyTextBold>{reviewer.fullName}</BodyTextBold>
                  <BodySmall>{`. ${reviewer.title}`}</BodySmall>
                </div>
                <MetaText element="time">{date}</MetaText>
              </span>
            </div>
          </div>
          <div className={styles.profileCard}>
            <Link href={`/profile/${profile.slug}`}>
              <a>
                <Card
                  imageUrl={profile.profilePicture?.cardUrl}
                  talentName={profile.name}
                  talentDescription={profile.title}
                  type="featured"
                  size="small"
                />
              </a>
            </Link>
          </div>
        </div>
      </Box>
    </div>
  )
}

export default BusinessReviewCard
